import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import gsap from 'gsap';

/**
 * PageTransition — transición cinematográfica entre rutas (fusión Monopo/Active Theory).
 * Cada cambio de ruta hace entrar el contenido desde scale 0.985 + opacity 0 (power3.out).
 * Respeta prefers-reduced-motion. No mantiene el árbol anterior montado (entrada únicamente,
 * fiable con React Router + Suspense).
 */
function PageTransition({ children }) {
  const ref = useRef(null);
  const { pathname } = useLocation();

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) {
      gsap.set(el, { clearProps: 'all', opacity: 1 });
      return;
    }
    const ctx = gsap.context(() => {
      gsap.fromTo(
        el,
        { opacity: 0, scale: 0.985, y: 10 },
        { opacity: 1, scale: 1, y: 0, duration: 0.55, ease: 'power3.out', clearProps: 'transform' }
      );
    }, ref);
    return () => ctx.revert();
  }, [pathname]);

  return (
    <div ref={ref} style={{ minHeight: '60vh' }}>
      {children}
    </div>
  );
}

export default PageTransition;
